import { Component } from '@angular/core';

@Component({
  selector: 'cil-simple-layout',
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss'],
})
export class SimpleLayoutComponent {}
